import Downshift, { DownshiftState, StateChangeOptions } from 'downshift';

/**
 * Extend (and override) the default downshift state reducer.
 *
 * @see https://github.com/downshift-js/downshift#statereducer
 */
export default function downshiftReducer<T>(
  state: DownshiftState<T>,
  changes: StateChangeOptions<T>
): Partial<StateChangeOptions<T>> {
  switch (changes.type) {
    // This overrides the default downshift behavior that clears the input value
    // whenever the selected item changes. We don't want that to clear as
    // the user might only want to change part of the input value.
    case Downshift.stateChangeTypes.controlledPropUpdatedSelectedItem:
      return { ...changes, inputValue: changes.inputValue || state.inputValue };

    // Keep all the other downshift defaults as they are.
    default:
      return changes;
  }
}
